import PropTypes from "prop-types";
import React from "react";

const CDCDependenciesContext = React.createContext(() => ({
  isVMSApp: false,
}));

export const WithCDCDependencies = Wrapped => {
  const WithConsumer = props => (
    <CDCDependenciesContext.Consumer>
      {dependencies => <Wrapped dependencies={dependencies} {...props} />}
    </CDCDependenciesContext.Consumer>
  );
  WithConsumer.displayName = getDisplayName(Wrapped);
  return WithConsumer;
};
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
// wrapping this so can validate w/ proptypes
export const CDCDependenciesProvider = ({ value, ...props }) => {
  return <CDCDependenciesContext.Provider value={value} {...props} />;
};

CDCDependenciesProvider.propTypes = {
  children: PropTypes.any,
  value: PropTypes.shape({
    submitSuggestion: PropTypes.func.isRequired,
    sendMixPanel: PropTypes.func,
    successToast: PropTypes.func,
    setMixPanelReferrer: PropTypes.func,
    user: PropTypes.object.isRequired,
  }),
};

export default CDCDependenciesContext;
